import { type ThirdPartyConfig } from '../../types/schemas/types';


import { adobeSignConfig } from './adobe-sign';
import { adobeXDConfig } from './adobe-xd';
import { ahaConfig } from './aha';
import { airtableConfig } from './airtable';
import { amplitudeConfig } from './amplitude';
import { asanaConfig } from './asana';
import { atlassianWebCrawlerConfig } from './atlassian-web-crawler';
import { awss3Config } from './aws-s3';
import { azureDevopsConfig } from './azure-devops';
import { boxConfig } from './box';
import { canvaConfig } from './canva';
import { clickUpConfig } from './clickup';
import { confluenceDCConfig } from './confluence-dc';
import { databricksConfig } from './databricks';
import { docusignConfig } from './docusign';
import { dovetailConfig } from './dovetail';
import { dropboxConfig } from './dropbox';
import { figmaConfig } from './figma';
import { forgeAdamVitareqConfig as forgeAdamVitareqDevConfig } from './forge-adam-vitareq-dev';
import { forgeAdamVitareqConfig as forgeAdamVitareqProdConfig } from './forge-adam-vitareq-prod';
import { forgeGdriveEugeneTestDevConfig } from './forge-gdrive-eugene-test-dev';
import { forgeGdriveEugeneTestProdConfig } from './forge-gdrive-eugene-test-prod';
import { forgeK15tScrollSitesConfig as forgeK15tScrollSitesDevConfig } from './forge-k15t-scroll-sites-dev';
import { forgeK15tScrollSitesConfig as forgeK15tScrollSitesProdConfig } from './forge-k15t-scroll-sites-prod';
import { forgePioAwsConfig as forgePioAwsDevConfig } from './forge-pio-aws-dev';
import { forgePioAwsConfig as forgePioAwsProdConfig } from './forge-pio-aws-prod';
import { forgePioClickupConfig as forgePioClickupDevConfig } from './forge-pio-clickup-dev';
import { forgePioClickupConfig as forgePioClickupProdConfig } from './forge-pio-clickup-prod';
import { forgePioGitbookConfig as forgePioGitbookDevConfig } from './forge-pio-gitbook-dev';
import { forgePioGitbookConfig as forgePioGitbookProdConfig } from './forge-pio-gitbook-prod';
import { forgePioGithubConfig as forgePioGithubDevConfig } from './forge-pio-github-dev';
import { forgePioGithubConfig as forgePioGithubProdConfig } from './forge-pio-github-prod';
import { forgePioGitlabConfig as forgePioGitlabDevConfig } from './forge-pio-gitlab-dev';
import { forgePioGitlabConfig as forgePioGitlabProdConfig } from './forge-pio-gitlab-prod';
import { forgePioGoogleDriveConfig as forgePioGoogleDriveDevConfig } from './forge-pio-google-drive-dev';
import { forgePioGoogleDriveConfig as forgePioGoogleDriveProdConfig } from './forge-pio-google-drive-prod';
import { forgePioGuruConfig as forgePioGuruDevConfig } from './forge-pio-guru-dev';
import { forgePioGuruConfig as forgePioGuruProdConfig } from './forge-pio-guru-prod';
import { forgePioHelpjuiceConfig as forgePioHelpjuiceDevConfig } from './forge-pio-helpjuice-dev';
import { forgePioHelpjuiceConfig as forgePioHelpjuiceProdConfig } from './forge-pio-helpjuice-prod';
import { forgePioHubspotConfig as forgePioHubspotDevConfig } from './forge-pio-hubspot-dev';
import { forgePioHubspotConfig as forgePioHubspotProdConfig } from './forge-pio-hubspot-prod';
import { forgePioSalesforceConfig as forgePioSalesforceDevConfig } from './forge-pio-salesforce-dev';
import { forgePioSalesforceConfig as forgePioSalesforceProdConfig } from './forge-pio-salesforce-prod';
import { forgePioSharepointConfig as forgePioSharepointDevConfig } from './forge-pio-sharepoint-dev';
import { forgePioSharepointConfig as forgePioSharepointProdConfig } from './forge-pio-sharepoint-prod';
import { forgePioStackOverflowConfig as forgePioStackOverflowDevConfig } from './forge-pio-stack-overflow-dev';
import { forgePioStackOverflowConfig as forgePioStackOverflowProdConfig } from './forge-pio-stack-overflow-prod';
import { forgeUnitoAsanaConfig as forgeUnitoAsanaDevConfig } from './forge-unito-asana-dev';
import { forgeUnitoAsanaConfig as forgeUnitoAsanaProdConfig } from './forge-unito-asana-prod';
import { forgeUnitoBasecampConfig as forgeUnitoBasecampDevConfig } from './forge-unito-basecamp-dev';
import { forgeUnitoBasecampConfig as forgeUnitoBasecampProdConfig } from './forge-unito-basecamp-prod';
import { forgeUnitoSalesforceConfig as forgeUnitoSalesforceDevConfig } from './forge-unito-salesforce-dev';
import { forgeUnitoSalesforceConfig as forgeUnitoSalesforceProdConfig } from './forge-unito-salesforce-prod';
import { forgeUnitoServicenowConfig as forgeUnitoServicenowDevConfig } from './forge-unito-servicenow-dev';
import { forgeUnitoServicenowConfig as forgeUnitoServicenowProdConfig } from './forge-unito-servicenow-prod';
import { forgeUnitoWrikeConfig as forgeUnitoWrikeDevConfig } from './forge-unito-wrike-dev';
import { forgeUnitoWrikeConfig as forgeUnitoWrikeProdConfig } from './forge-unito-wrike-prod';
import { forgeUtoolityGitbookConfig as forgeUtoolityGitbookDevConfig } from './forge-utoolity-gitbook-dev';
import { forgeUtoolityGitbookConfig as forgeUtoolityGitbookProdConfig } from './forge-utoolity-gitbook-prod';
import { freshserviceConfig } from './freshservice';
import { gitbookConfig } from './gitbook';
import { githubConfig } from './github';
import { gitlabConfig } from './gitlab';
import { gmailConfig } from './gmail';
import { googleDriveConfig } from './google';
import { googleCalendarConfig } from './google-calendar';
import { hubSpotConfig } from './hubspot';
import { jiraDCConfig } from './jira-dc';
import { jsmDCConfig } from './jsm-dc';
import { launchDarklyConfig } from './launchdarkly';
import { loomConfig } from './loom';
import { lucidConfig } from './lucid';
import { miroConfig } from './miro';
import { mondayConfig } from './monday';
import { muralConfig } from './mural';
import { notionConfig } from './notion';
import { oneDriveConfig } from './onedrive';
import { outlookCalendarConfig } from './outlook-calendar';
import { outlookMail } from './outlook-mail';
import { pagerDutyConfig } from './pagerduty';
import { pipedriveConfig } from './pipedrive';
import { powerBIConfig } from './powerBI';
import { salesforceConfig } from './salesforce';
import { sentryConfig } from './sentry';
import { serviceNowConfig } from './servicenow';
import { sharepointConfig } from './sharepoint';
import { slackConfig } from './slack';
import { smartsheetConfig } from './smartsheet';
import { stripeConfig } from './stripe';
import { teamsConfig } from './teams';
import { todoistConfig } from './todoist';
import { ProductKeys3P } from './types';
import { webexConfig } from './webex';
import { zendeskConfig } from './zendesk';
import { zeplinConfig } from './zeplin';

export const ThirdPartyConfigsSync: Map<ProductKeys3P, ThirdPartyConfig> = new Map<ProductKeys3P, ThirdPartyConfig>([
	[ProductKeys3P.AtlassianWebCrawler, atlassianWebCrawlerConfig],
	[ProductKeys3P.Figma, figmaConfig],
	[ProductKeys3P.Github, githubConfig],
	[ProductKeys3P.GoogleDrive, googleDriveConfig],
	[ProductKeys3P.Sharepoint, sharepointConfig],
	[ProductKeys3P.Loom, loomConfig],
	[ProductKeys3P.OneDrive, oneDriveConfig],
	[ProductKeys3P.Dropbox, dropboxConfig],
	[ProductKeys3P.Slack, slackConfig],
	[ProductKeys3P.Teams, teamsConfig],
	[ProductKeys3P.GoogleCalendar, googleCalendarConfig],
	[ProductKeys3P.Gmail, gmailConfig],
	[ProductKeys3P.OutlookCalendar, outlookCalendarConfig],
	[ProductKeys3P.OutlookMail, outlookMail],
	[ProductKeys3P.Asana, asanaConfig],
	[ProductKeys3P.Zendesk, zendeskConfig],
	[ProductKeys3P.Airtable, airtableConfig],
	[ProductKeys3P.Smartsheet, smartsheetConfig],
	[ProductKeys3P.Notion, notionConfig],
	[ProductKeys3P.Miro, miroConfig],
	[ProductKeys3P.Docusign, docusignConfig],
	[ProductKeys3P.Lucid, lucidConfig],
	[ProductKeys3P.Monday, mondayConfig],
	[ProductKeys3P.AzureDevops, azureDevopsConfig],
	[ProductKeys3P.Gitlab, gitlabConfig],
	[ProductKeys3P.ConfluenceDC, confluenceDCConfig],
	[ProductKeys3P.JiraDC, jiraDCConfig],
	[ProductKeys3P.JsmDC, jsmDCConfig],
	[ProductKeys3P.Canva, canvaConfig],
	[ProductKeys3P.Box, boxConfig],
	[ProductKeys3P.Zeplin, zeplinConfig],
	[ProductKeys3P.ServiceNow, serviceNowConfig],
	[ProductKeys3P.Freshservice, freshserviceConfig],
	[ProductKeys3P.PowerBI, powerBIConfig],
	[ProductKeys3P.ClickUp, clickUpConfig],
	[ProductKeys3P.Amplitude, amplitudeConfig],
	[ProductKeys3P.Stripe, stripeConfig],
	[ProductKeys3P.AdobeXD, adobeXDConfig],
	[ProductKeys3P.Aha, ahaConfig],
	[ProductKeys3P.AdobeSign, adobeSignConfig],
	[ProductKeys3P.Mural, muralConfig],
	[ProductKeys3P.Webex, webexConfig],
	[ProductKeys3P.Todoist, todoistConfig],
	[ProductKeys3P.PagerDuty, pagerDutyConfig],
	[ProductKeys3P.Pipedrive, pipedriveConfig],
	[ProductKeys3P.Hubspot, hubSpotConfig],
	[ProductKeys3P.Dovetail, dovetailConfig],
	[ProductKeys3P.LaunchDarkly, launchDarklyConfig],
	[ProductKeys3P.Salesforce, salesforceConfig],
	[ProductKeys3P.Sentry, sentryConfig],
	[ProductKeys3P.Gitbook, gitbookConfig],
	[ProductKeys3P.AWSS3, awss3Config],
	[ProductKeys3P.Databricks, databricksConfig],
	[ProductKeys3P.ForgeAdamVitareqDev, forgeAdamVitareqDevConfig],
	[ProductKeys3P.ForgeAdamVitareqProd, forgeAdamVitareqProdConfig],
	[ProductKeys3P.ForgeK15tScrollSitesDev, forgeK15tScrollSitesDevConfig],
	[ProductKeys3P.ForgeK15tScrollSitesProd, forgeK15tScrollSitesProdConfig],
	[ProductKeys3P.ForgePioAwsDev, forgePioAwsDevConfig],
	[ProductKeys3P.ForgePioAwsProd, forgePioAwsProdConfig],
	[ProductKeys3P.ForgePioClickupDev, forgePioClickupDevConfig],
	[ProductKeys3P.ForgePioClickupProd, forgePioClickupProdConfig],
	[ProductKeys3P.ForgePioGitbookDev, forgePioGitbookDevConfig],
	[ProductKeys3P.ForgePioGitbookProd, forgePioGitbookProdConfig],
	[ProductKeys3P.ForgePioGithubDev, forgePioGithubDevConfig],
	[ProductKeys3P.ForgePioGithubProd, forgePioGithubProdConfig],
	[ProductKeys3P.ForgePioGitlabDev, forgePioGitlabDevConfig],
	[ProductKeys3P.ForgePioGitlabProd, forgePioGitlabProdConfig],
	[ProductKeys3P.ForgePioGoogleDriveDev, forgePioGoogleDriveDevConfig],
	[ProductKeys3P.ForgePioGoogleDriveProd, forgePioGoogleDriveProdConfig],
	[ProductKeys3P.ForgePioGuruDev, forgePioGuruDevConfig],
	[ProductKeys3P.ForgePioGuruProd, forgePioGuruProdConfig],
	[ProductKeys3P.ForgePioHelpjuiceDev, forgePioHelpjuiceDevConfig],
	[ProductKeys3P.ForgePioHelpjuiceProd, forgePioHelpjuiceProdConfig],
	[ProductKeys3P.ForgePioHubspotDev, forgePioHubspotDevConfig],
	[ProductKeys3P.ForgePioHubspotProd, forgePioHubspotProdConfig],
	[ProductKeys3P.ForgePioSalesforceDev, forgePioSalesforceDevConfig],
	[ProductKeys3P.ForgePioSalesforceProd, forgePioSalesforceProdConfig],
	[ProductKeys3P.ForgePioSharepointDev, forgePioSharepointDevConfig],
	[ProductKeys3P.ForgePioSharepointProd, forgePioSharepointProdConfig],
	[ProductKeys3P.ForgePioStackOverflowDev, forgePioStackOverflowDevConfig],
	[ProductKeys3P.ForgePioStackOverflowProd, forgePioStackOverflowProdConfig],
	[ProductKeys3P.ForgeUtoolityGitbookDev, forgeUtoolityGitbookDevConfig],
	[ProductKeys3P.ForgeUtoolityGitbookProd, forgeUtoolityGitbookProdConfig],
	[ProductKeys3P.ForgeGdriveEugeneTestDev, forgeGdriveEugeneTestDevConfig],
	[ProductKeys3P.ForgeGdriveEugeneTestProd, forgeGdriveEugeneTestProdConfig],
	[ProductKeys3P.ForgeUnitoSalesforceDev, forgeUnitoSalesforceDevConfig],
	[ProductKeys3P.ForgeUnitoSalesforceProd, forgeUnitoSalesforceProdConfig],
	[ProductKeys3P.ForgeUnitoServicenowDev, forgeUnitoServicenowDevConfig],
	[ProductKeys3P.ForgeUnitoServicenowProd, forgeUnitoServicenowProdConfig],
	[ProductKeys3P.ForgeUnitoWrikeDev, forgeUnitoWrikeDevConfig],
	[ProductKeys3P.ForgeUnitoWrikeProd, forgeUnitoWrikeProdConfig],
	[ProductKeys3P.ForgeUnitoAsanaDev, forgeUnitoAsanaDevConfig],
	[ProductKeys3P.ForgeUnitoAsanaProd, forgeUnitoAsanaProdConfig],
	[ProductKeys3P.ForgeUnitoBasecampDev, forgeUnitoBasecampDevConfig],
	[ProductKeys3P.ForgeUnitoBasecampProd, forgeUnitoBasecampProdConfig],
]);
